var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 4V2a.667.667 0 0 1 .666-.667h8A.667.667 0 0 1 14 2v9.333a.666.666 0 0 1-.667.667h-2v2c0 .368-.3.667-.671.667h-7.99A.667.667 0 0 1 2 14l.002-9.333c0-.368.3-.667.671-.667zM3.335 5.333l-.002 8H10v-8zM6 4h5.333v6.667h1.334v-8H6z"
  })));
};
export default SvgCopy;